import React from 'react';
import { IBillerDef, IUIDomainImageDef, IUIImageDef } from '../../datatypes';
import Col from '../base-components/Col'
import { BaseUIComponentProps, replaceBillerInfo } from './BaseUIComponent';

interface ImageProps extends BaseUIComponentProps {
    metadata:IUIImageDef|IUIDomainImageDef;
    src?: string; // ???
}

export default class Image extends React.Component<ImageProps,{}> {

  render() {
    const {
      properties,
      src,
      height,
      width,
      altText,
      text,
      cssClasses,
      imageCSSClasses,
      textCSSClasses
    } = this.props.metadata;
    let {xs, sm, md, lg} = properties;
    let className = cssClasses ? cssClasses : '';

    //the faClassName is added only for fa icons only.
    let faClassName = "far" + " fa-"+imageCSSClasses + ((width || height) ? " fa-" + (width ? width : height) : "");
    let textClassName = textCSSClasses ? textCSSClasses : '';

    let billerText = replaceBillerInfo(text, this.props.formBean.Biller);
    let billerSrc = replaceBillerInfo(src, this.props.formBean.Biller);
    // TODO: what is this.props.src?
    let finalSrc = this.props.src ? this.props.src : billerSrc;

    //Need an alternate when altText is empty. To pass ADA compliance.
    let urlSplit = finalSrc ? finalSrc.split('/') : null;
    let imgName = urlSplit && urlSplit.length>0 ? urlSplit[urlSplit.length - 1] : '';

    return (
      <Col xs={xs} sm={sm} md={md} lg={lg} className={className}>
        {["fa", "fas", "far"].includes(finalSrc) ?
          <i className={faClassName} />:
          <div className={'ui-renderer-img-comp-outer-div'} style={{maxHeight:height, maxWidth:width}}>
            <img
            style={{maxHeight: height}}
            className={'ui-renderer-img-comp ' + imageCSSClasses}
            alt={altText || imgName}
            src={finalSrc}
          /></div>
        }
        {billerText ? <span className={textClassName}>{billerText}</span> : null }
      </Col>
    )
  }
}